import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-add-new-gl-setup',
  templateUrl: './add-new-gl-setup.component.html',
  styleUrls: ['./add-new-gl-setup.component.scss']
})
export class AddNewGlSetupComponent implements OnInit {

  private _newGlCodeTextValue: string = '';
  private _newGlDescriptionTextValue: string = '';
  @Output() glCodeValid = new EventEmitter<boolean>();
  constructor() {
  }

  ngOnInit() {
  }

  get newGlCodeTextValue(): string {
    return this._newGlCodeTextValue;
  }

  set newGlCodeTextValue(value: string) {
    this._newGlCodeTextValue = value;
    this.glCodeValid.emit(!!value.trim()); 
  }

  get newGlDescriptionTextValue(): string {
    return this._newGlDescriptionTextValue;
  }

  set newGlDescriptionTextValue(value: string) {
    this._newGlDescriptionTextValue = value;
  }

  newGlCodeTextBoxChange(newValue) {
    this._newGlCodeTextValue = newValue;
  }

  newGlDescriptionTextBoxChange(newValue) {
    this._newGlDescriptionTextValue = newValue;
  }
}
